import i18n from 'i18next';

export default {
   details: i18n.t('details.tabName'),
   privacy: i18n.t('privacy.tabName'),
   analytics: i18n.t('analytics.tabName'),
   editMedia: i18n.t('editMedia.tabName'),
   accessibility: i18n.t('accessibility.tabName'),
   quizzing: i18n.t('quizzing.tabName'),
   conversations: i18n.t('conversations.tabName'),
   conversation: i18n.t('conversations.ConversationLabel'),
   comments: i18n.t('comments.tabName'),
   transcript: i18n.t('transcript.tabName'),
   settings: i18n.t('Settings')
};
